import styled from "styled-components";

export const SelectionCard = styled.div<{ isSelected: boolean }>`
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 17px;
  background: ${({ theme }) => theme.colors.white};
  border: ${({ theme, isSelected }) =>
    isSelected
      ? `2px solid ${theme.colors.brand["500"]}`
      : `1.5px solid ${theme.colors.periwinkle["500"]}`};
  box-sizing: border-box;
  border-radius: 6px;
  cursor: pointer;
`;

export const ImageContainer = styled.div`
  width: 72px;
  height: 72px;
  position: relative;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
`;

export const Heading = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.lg};
  line-height: 28px;
  color: ${({ theme }) => theme.colors.black};
  margin: 0;
`;

export const SubHeading = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-style: normal;
  font-weight: normal;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral["600"]};
  margin: 0;
`;
